/**
 * The microphone glyphs — open, and struck through — for every widget with a
 * mute control. Hand-drawn inline SVG in `currentColor`, for the reason every
 * glyph in this directory is: these components ship inside the public embed,
 * where an icon library is somebody else's kilobytes and a stylesheet may not
 * have loaded at all. First drawn for the chat flag's header; shared since the
 * side flag grew a mute control of its own (2026-09-01), so the two flags show
 * the same microphone.
 */

export function MicGlyph({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden focusable="false">
      <path d="M12 2a3.5 3.5 0 0 0-3.5 3.5v6a3.5 3.5 0 0 0 7 0v-6A3.5 3.5 0 0 0 12 2Z" />
      <path d="M5.5 10.5a1 1 0 0 1 1 1 5.5 5.5 0 0 0 11 0 1 1 0 1 1 2 0 7.5 7.5 0 0 1-6.5 7.44V21h2a1 1 0 1 1 0 2h-6a1 1 0 1 1 0-2h2v-2.06A7.5 7.5 0 0 1 4.5 11.5a1 1 0 0 1 1-1Z" />
    </svg>
  )
}

export function MicOffGlyph({ size }: { size: number }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden focusable="false">
      <path d="M15.5 11.5V5.5a3.5 3.5 0 0 0-6.87-.95l6.8 6.8a3.6 3.6 0 0 0 .07-.85ZM8.5 8.62v2.88a3.5 3.5 0 0 0 4.88 3.22L8.5 8.62Z" />
      <path d="M19.5 11.5a1 1 0 1 0-2 0 5.47 5.47 0 0 1-.83 2.9l1.46 1.46a7.44 7.44 0 0 0 1.37-4.36ZM6.5 11.5a1 1 0 1 0-2 0 7.5 7.5 0 0 0 6.5 7.44V21H9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-2v-2.06a7.4 7.4 0 0 0 2.2-.66l-1.53-1.53a5.5 5.5 0 0 1-7.17-5.25Z" />
      <path d="M3.7 2.29a1 1 0 0 0-1.41 1.42l18 18a1 1 0 0 0 1.42-1.42l-18-18Z" />
    </svg>
  )
}
